import {privateRoutes} from "./privateRoutes";
import {publicRoutes} from "./publicRoutes";

export const routes = [
    ...privateRoutes,
    ...publicRoutes
];
